import apiServices from "../common/apiServices";

export const addTagTypes = ['Notifications'];

const NotificationsApi = apiServices
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      // Get all notifications
      getNotifications: build.query({
        query: () => ({
          url: '/notificationsManual',
        }),
        providesTags: ['Notifications'],
        transformResponse: (response) => {
          const data = response || [];
          return data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        },
      }),

      // Get paginated notifications
      getNotificationsPaginated: build.query({
        query: ({ userId, page = 0, size = 10 }) => ({
          url: `/notificationsManual/user/${userId}/paged?page=${page}&size=${size}`,
        }),
        providesTags: ['Notifications'],
      }),

      // Mark single notification as read
      markNotificationAsRead: build.mutation({
        query: (id) => ({
          url: `/notificationsManual/${id}/read`,
          method: 'PATCH',
        }),
        invalidatesTags: ['Notifications'],
        async onQueryStarted(id, { dispatch, queryFulfilled }) {
          const patchResult = dispatch(
            NotificationsApi.util.updateQueryData(
              'getNotifications',
              undefined,
              (draft) => {
                const notification = draft.find((n) => n.id === id);
                if (notification) notification.read = true;
              }
            )
          );
          try {
            await queryFulfilled;
          } catch {
            patchResult.undo();
          }
        },
      }),

      // Mark all notifications as read
      markAllNotificationsAsRead: build.mutation({
        query: (userId) => ({
          url: `/notificationsManual/user/${userId}/mark-all-read`,
          method: 'PATCH',
        }),
        invalidatesTags: ['Notifications'],
        async onQueryStarted(arg, { dispatch, queryFulfilled }) {
          const patchResult = dispatch(
            NotificationsApi.util.updateQueryData(
              'getNotifications',
              undefined,
              (draft) => {
                draft.forEach((n) => (n.read = true));
              }
            )
          );
          try {
            await queryFulfilled;
          } catch {
            patchResult.undo();
          }
        },
      }),
    }),
    overrideExisting: false,
  });

// Base hooks (original RTK Query hooks)
export const {
  useGetNotificationsQuery: useGetNotificationsBaseQuery,
  useGetNotificationsPaginatedQuery: useGetNotificationsPaginatedBaseQuery,
  useMarkNotificationAsReadMutation,
  useMarkAllNotificationsAsReadMutation,
} = NotificationsApi;

// Enhanced hooks with automatic polling
export const useGetNotificationsQuery = (options) => {
  return useGetNotificationsBaseQuery(undefined, {
    pollingInterval: 5000, // Default: 5-second refresh
    refetchOnMountOrArgChange: true,
    ...options, // Allow overrides
  });
};

export const useGetNotificationsPaginatedQuery = (params, options) => {
  return useGetNotificationsPaginatedBaseQuery(params, {
    pollingInterval: 5000, // Default: 5-second refresh
    refetchOnMountOrArgChange: true,
    ...options, // Allow overrides
  });
};

export default NotificationsApi;